import React from 'react';
export const MEDIA_WRAPPER_TAG = 'data-media-vc-wrapper';
export const VcMediaWrapperProps = {
  [MEDIA_WRAPPER_TAG]: true
};
export default function MediaWrapper({
  children
}) {
  return /*#__PURE__*/React.createElement("div", VcMediaWrapperProps, children);
}